export default import.meta.ROLLDOWN_FILE_URL_veQ2AzMWG1LN0$lYRxQ8qw